<template>
  <div class="card">
    <draggable
      :id="shipment.id"
      data-source="juju"
      :list="shipment.orders"
      class="list-group"
      draggable=".item"
      :metadata="shipment.metadata"
      group="a"
      :sort="false"
      @end="onMovedOrder"
      @start="fromOrder"
    >
      <template v-if="showOrders">
        <order-item
          :id="orderItem.id"
          v-for="(orderItem, numb) in shipment.orders"
          :order="orderItem"
          :index="numb + startOrderNum"
          :key="orderItem.number"
          hasShipment
          @clickOrderInfo="onClickOrderInfo(orderItem)"
          @clickIconMove="onClickIconMove(shipment, orderItem)"
          @clickDeleteOrder="onClickDeleteOrder(orderItem)"
          @clickIconUnassign="onClickIconUnassign(orderItem)"
          @clickCreateLocation="onClickCreateLocation(orderItem)"
        />
      </template>
      <div
        slot="header"
        :class="setClassHeader()"
        role="group"
        aria-label="Basic example"
        v-if="shipment.number"
      >
        <div>
          <p class="mb-1 d-inline-block" style="text-align: left">
            <b>{{ shipment.number }}</b>
          </p>
          <a
            href="#"
            v-if="shipment.state === 'CREATED'"
            @click.prevent="setShipmentState('READY_TO_LOAD')"
            title="Done"
            style="font-size: 1rem"
            class="pull-right p-2 mt-n2 mr-n1 text-body"
            ><i class="fa fa-check-square-o"></i
          ></a>
          <a
            href="#"
            v-if="shipment.state === 'READY_TO_LOAD'"
            @click.prevent="setShipmentState('CREATED')"
            title="Rearrange"
            style="font-size: 1rem"
            class="pull-right p-2 mt-n2 mr-n1 text-body"
            ><i class="fa fa-toggle-up"></i
          ></a>
           <a
            href="#"
            @click="onClickSwitchVehicle(shipment)"
            title="Switch Vehicle"
            style="font-size: 0.9rem"
            class="pull-right p-2 mt-n2 mr-n1 text-body"
            ><i class="fa fa-car"></i
          ></a>
        </div>
        <p v-if="shipment.driver" class="mb-1" style="text-align: left">
          Driver: {{ get(shipment, "driver.name") }}
        </p>
        <p v-if="shipment.vehicle || isTruckOnCall" class="mb-1" style="text-align: left">
          {{ regNo }}
          <span
            >&#8226; {{ storageType }}</span
          >
          <span
            title="CDD"
            v-if="isVehicleCDD"
            class="ml-1 mr-1"
          >
            <i class="fa fa-truck"></i>
          </span>
          <span
            title="Standby"
            v-if="
              parseInt(get(shipment, 'vehicle.metadata.standby', '0'), 10) === 1
            "
            class="ml-1 mr-1"
          >
            <i class="fa fa-clock-o"></i>
          </span>
        </p>
        <p class="mb-1" v-if="shipment.vehicle || isTruckOnCall">
          {{ workingArea }}
        </p>
        <b-row v-if="shipment.vehicle || isTruckOnCall" align-h="between">
          <b-col>
            <p class="my-1">
              Weight:
              <b >{{ totalGross }}
                / {{ maxWeight }}</b
              >
              <br />
              Volume:
              <b >{{ totalVolume }}
                / {{ maxVolume }}</b
              >
            </p>
            <p class="my-1" v-if="shipment.orders.length" v-html="orderSummary()"></p>
          </b-col>
          <b-col cols="auto">
            <div v-if="isShipmentOverload.overload" class="mb-2">
              <b-badge variant="danger">OVERLOAD</b-badge>
            </div>
            <b-button
              v-if="shipment.orders.length"
              @click="showMapModal"
              title="Preview Route"
              class="px-2"
              pill
              variant="light"
            >
              <i class="fa fa-map-pin"></i>
            </b-button>
            <a v-if="shipment.orders.length" class="d-block mt-3 text-body"
              @click.prevent="showOrders = !showOrders"
              href="#">{{ showOrders ? 'Hide' : 'Show' }} <i :class="{'fa-chevron-up': showOrders, 'fa-chevron-down': !showOrders}" class="fa"></i>
            </a>
          </b-col>
        </b-row>
      </div>
    </draggable>
  </div>
</template>
<script>
import { round, get, isArray, sumBy, isObject } from 'lodash';
import draggable from 'vuedraggable';
import OrderItem from './OrderItem.vue';

export default {
  components: { OrderItem, draggable },
  props: {
    shipment: {
      type: Object,
      required: true,
    },
    initShowOrders: {
      type: Boolean,
      required: false,
      default: true,
    },
    startOrderNum: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      showOrders: this.initShowOrders,
    };
  },
  computed: {
    totalGross() {
      return this.shipmentSumFromOrder('metadata.total_gross_weight');
    },
    totalVolume() {
      return this.shipmentSumFromOrder('metadata.total_gross_volume');
    },
    maxWeight() {
      return !this.isTruckOnCall ?
        parseFloat(get(this.shipment, 'vehicle.metadata.max_weight', 0)) :
        parseFloat(get(this.truckOnCallInfo, 'max_weight', 0));
    },
    maxVolume() {
      return !this.isTruckOnCall ?
        parseFloat(get(this.shipment, 'vehicle.metadata.max_volume', 0)) :
        parseFloat(get(this.truckOnCallInfo, 'max_volume', 0));
    },
    isShipmentOverload() {
      const byVolume = this.totalVolume > this.maxVolume;
      const byWeight = this.totalGross > this.maxWeight;
      return {
        overload: byVolume || byWeight,
        byVolume,
        byWeight,
      };
    },
    regNo() {
      return !this.isTruckOnCall ?
        get(this.shipment, 'vehicle.reg_no') :
        this.truckOnCallInfo.plate_no;
    },
    storageType() {
      return !this.isTruckOnCall ?
        get(this.shipment, 'vehicle.metadata.storage_type') :
        this.truckOnCallInfo.type_full;
    },
    workingArea() {
      return !this.isTruckOnCall ?
        get(this.shipment, 'vehicle.metadata.working_area', []).join(', ') :
        this.truckOnCallInfo.ori_area;
    },
    isVehicleCDD() {
      if (this.isTruckOnCall) {
        return this.truckOnCallInfo.big_size !== 0;
      }
      const cdd = get(this.shipment, 'vehicle.metadata.cdd');
      const isCdd = Number(cdd) === 1;
      return isCdd;
    },
    truckOnCallInfo() {
      return get(this.shipment, 'metadata.truck_on_call_info');
    },
    isTruckOnCall() {
      return isObject(this.truckOnCallInfo);
    },
  },
  methods: {
    get(...args) {
      return get(...args);
    },
    onClickSwitchVehicle(...args) {
      this.$emit('clickSwitchVehicle', ...args);
    },
    onMovedOrder(...args) {
      this.$emit('movedOrder', ...args);
    },
    fromOrder(...args) {
      this.$emit('fromOrder', ...args);
    },
    onClickOrderInfo(...args) {
      this.$emit('clickOrderInfo', ...args);
    },
    onClickIconMove(...args) {
      this.$emit('clickIconMove', ...args);
    },
    showMapModal(...args) {
      this.$emit('showMapModal', ...args);
    },
    onClickCreateLocation(...args) {
      this.$emit('clickCreateLocation', ...args);
    },
    onClickDeleteOrder(order) {
      this.$swal({
        title: 'Confirmation',
        html: `Are you sure want to delete this order <b>(${order.number})</b> ?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (!result.value) {
          return;
        }
        this.$store
          .dispatch('shipment_md/orders/DELETE_DATA', order.id)
          .then(() => {
            const index = this.shipment.orders.indexOf(order);
            if (index > -1) {
              this.shipment.orders.splice(index, 1);
            }
          });
      });
    },
    onClickIconUnassign(order) {
      const index = this.shipment.orders.indexOf(order);
      if (index > -1) {
        this.shipment.orders.splice(index, 1);
        const unassigned = this.routing_summary.find(r => r.type === 'unassigned');
        if (unassigned && isArray(unassigned.orders)) {
          unassigned.orders.push(order);
        }
        this.$emit('requestSnapshot');
      }
    },
    setClassHeader() {
      let headerClass = 'list-group-item header';
      const { metadata } = this.shipment;
      let storageType = metadata ? metadata.storage_type : '';
      storageType = storageType.toUpperCase();

      switch (storageType) {
        case 'DRY':
          headerClass += ' storage-dry';
          break;
        case 'CHILLER':
          headerClass += ' storage-chiller';
          break;
        case 'FROZEN':
          headerClass += ' storage-frozen';
          break;
        case 'COMBINE':
          headerClass += ' storage-combine';
          break;
        default:
          headerClass += '';
          break;
      }

      return headerClass;
    },
    setShipmentState(state) {
      const payloads = {
        id: this.shipment.id,
        state,
      };
      this.shipment.state = state;
      this.$store
        .dispatch('shipment_md/shipments/UPDATE_SHIPMENT_STATE', payloads);
    },
    shipmentSumFromOrder(key) {
      return round(sumBy(this.shipment.orders, o => parseFloat(get(o, key, 0))), 2);
    },
    orderSummary() {
      const totalOrder = this.shipment.orders.length;
      const totalDelivery = this.shipment.orders.reduce((total, order) => {
        let key = `O:${order.id}`;
        if (get(order, 'destination.id')) {
          key = `D:${get(order, 'destination.id')}`;
        }
        if (total.recorded.indexOf(key) < 0) {
          total.recorded.push(key);
          total.count += 1;
        }
        return total;
      }, { recorded: [], count: 0 }).count;
      return `Orders: ${totalOrder} &#8226; Drop Point: ${totalDelivery}`;
    },
  },
};
</script>
<style lang="sass">
.storage-dry
  background-color: #FFF9C4;

.storage-chiller
  background-color: #BBDEFB;

.storage-frozen
  background-color: #81D4FA;

.storage-combine
  background-color: #A5D6A7;
</style>



// WEBPACK FOOTER //
// src/components/shipment_md/ShipmentBoxItem.vue